import { createSelector } from 'reselect';
import { getLoadingStatuses } from 'helpers/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getGatewayInformation = ({ powertrainTools }) => {
    return powertrainTools?.gatewayInformation;
};

const getGatewayConnectedAssets = ({ powertrainTools }) => {
    return powertrainTools?.gatewayConnectedAssets;
};

const getSelectedOrganization = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.organizations[0];
};
const getIsMoveValid = ({ powertrainTools }) => {
    return powertrainTools?.validateGatewayAsset?.isMoveValid;
};

const getValidationLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.validateGatewayAsset?.loadingStatus;
};

const getIsSwitchValid = ({ powertrainTools }) => {
    return powertrainTools?.validateSwitchGatewayAsset?.isMoveValid;
};
const getValidateSwitchLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.validateSwitchGatewayAsset?.loadingStatus;
};
const getGatewayAssetsList = ({ powertrainTools }) => {
    return powertrainTools?.validateSwitchGatewayAsset?.assetList;
};
const getSwitchGatewayId = ({ powertrainTools }) => {
    return powertrainTools?.validateSwitchGatewayAsset?.switchGatewayId || null;
};

const getGatewayAssetsListLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.validateSwitchGatewayAsset?.assetListLoadingStatus;
};
const getIsSwitchEgwToAnotherGateway = ({ powertrainTools }) => {
    return powertrainTools?.validateSwitchGatewayAsset?.isSwitchEgwToAnotherGateway;
};

const getConnectionHistoryGateway = ({ powertrainTools }) => {
    return powertrainTools?.connectionHistoryGateway?.gatewayConnectionHistory;
};

const getMoveToAnotherGatewayError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.validateGatewayAsset?.loadingStatus,
        error: powertrainTools?.validateGatewayAsset?.error,
        errorCode: powertrainTools?.validateGatewayAsset?.error?.statusCode
    };
};

// Memoized selector for default move to another gateway error data
const getMoveToAnotherGatewayErrorData = createErrorDataSelector(getMoveToAnotherGatewayError);

const getRebootGatewayError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.rebootGateway?.loadingStatus,
        error: powertrainTools?.rebootGateway?.error,
        errorCode: powertrainTools?.rebootGateway?.error?.statusCode
    };
};

// Memoized selector for default reboot gateway error data
const getRebootGatewayErrorData = createErrorDataSelector(getRebootGatewayError);

const getUpdateFirmwareError = ({ powertrainTools }) => {
    // return powertrainTools?.updateFirmware;
    return {
        loadingStatus: powertrainTools?.updateFirmware?.loadingStatus,
        error: powertrainTools?.updateFirmware?.error,
        errorCode: powertrainTools?.updateFirmware?.error?.statusCode
    };
};

// Memoized selector for default update firmware error data
const getUpdateFirmwareErrorData = createErrorDataSelector(getUpdateFirmwareError);

const getRefreshGatewayError = ({ powertrainTools }) => {
    // return powertrainTools?.refreshGateway;
    return {
        loadingStatus: powertrainTools?.refreshGateway?.loadingStatus,
        error: powertrainTools?.refreshGateway?.error,
        errorCode: powertrainTools?.refreshGateway?.error?.statusCode
    };
};

// Memoized selector for default refresh gateway error data
const getRefreshGatewayErrorData = createErrorDataSelector(getRefreshGatewayError);

const getActivateDeactivateGatewayError = ({ powertrainTools }) => {
    // return powertrainTools?.activateDeactivateGateway;
    return {
        loadingStatus: powertrainTools?.activateDeactivateGateway?.loadingStatus,
        error: powertrainTools?.activateDeactivateGateway?.error,
        errorCode: powertrainTools?.activateDeactivateGateway?.error?.statusCode
    };
};

// Memoized selector for default activate/deactivate gateway error data
const getActivateDeactivateGatewayErrorData = createErrorDataSelector(getActivateDeactivateGatewayError);

const getLastCommandStatusError = ({ powertrainTools }) => {
    // return powertrainTools?.lastCommandStatus;
    return {
        loadingStatus: powertrainTools?.lastCommandStatus?.loadingStatus,
        error: powertrainTools?.lastCommandStatus?.error,
        errorCode: powertrainTools?.lastCommandStatus?.error?.statusCode
    };
};

// Memoized selector for default last command status error data
const getLastCommandStatusErrorData = createErrorDataSelector(getLastCommandStatusError);

const getDeleteGatewayError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.deleteGateway?.loadingStatus,
        error: powertrainTools?.deleteGateway?.error,
        errorCode: powertrainTools?.deleteGateway?.error?.statusCode
    };
};

// Memoized selector for default delete gateway error data
const getDeleteGatewayErrorData = createErrorDataSelector(getDeleteGatewayError);

const getInstallationReportError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.installationReport?.loadingStatus,
        error: powertrainTools?.installationReport?.error,
        errorCode: powertrainTools?.installationReport?.error?.statusCode
    };
};

// Memoized selector for default installation report error data
const getInstallationReportErrorData = createErrorDataSelector(getInstallationReportError);

const getDeleteAssetError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.deleteAsset?.loadingStatus,
        error: powertrainTools?.deleteAsset?.error,
        errorCode: powertrainTools?.deleteAsset?.error?.statusCode
    };
};

// Memoized selector for default delete asset error data
const getDeleteAssetErrorData = createErrorDataSelector(getDeleteAssetError);

const getDownloadDiagnosticReportError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.downloadDiagnosticReport?.loadingStatus,
        error: powertrainTools?.downloadDiagnosticReport?.error,
        errorCode: powertrainTools?.downloadDiagnosticReport?.error?.statusCode
    };
};

// Memoized selector for default download diagnostic report error data
const getDownloadDiagnosticReportErrorData = createErrorDataSelector(getDownloadDiagnosticReportError);

const getValidateSwitchGatewayAssetError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.validateSwitchGatewayAsset?.loadingStatus,
        error: powertrainTools?.validateSwitchGatewayAsset?.error,
        errorCode: powertrainTools?.validateSwitchGatewayAsset?.error?.statusCode
    };
};

// Memoized selector for default validate switch gateway asset error data
const getValidateSwitchGatewayAssetErrorData = createErrorDataSelector(getValidateSwitchGatewayAssetError);


export const getModel = createSelector(
    [
        getGatewayInformation,
        getGatewayConnectedAssets,
        getLoadingStatuses,
        getSelectedOrganization,
        getIsSwitchValid,
        getValidateSwitchLoadingStatus,
        getGatewayAssetsList,
        getGatewayAssetsListLoadingStatus,
        getIsSwitchEgwToAnotherGateway,
        getIsMoveValid,
        getSwitchGatewayId,
        getValidationLoadingStatus,
        getRebootGatewayErrorData,
        getUpdateFirmwareErrorData,
        getRefreshGatewayErrorData,
        getActivateDeactivateGatewayErrorData,
        getLastCommandStatusErrorData,
        getDeleteGatewayErrorData,
        getInstallationReportErrorData,
        getDeleteAssetErrorData,
        getMoveToAnotherGatewayErrorData,
        getDownloadDiagnosticReportErrorData,
        getValidateSwitchGatewayAssetErrorData,
        getConnectionHistoryGateway
    ],
    (
        gatewayInformation,
        gatewayConnectedAssets,
        generalFilterLoadingStatuses,
        selectedOrganization,
        isSwitchValid,
        validateSwitchLoadingStatus,
        gatewayAssetsList,
        gatewayAssetsListLoadingStatus,
        isSwitchEgwToAnotherGateway,
        isMoveValid,
        switchGatewayId,
        validationLoadingStatus,
        rebootGatewayErrorData,
        updateFirmwareErrorData,
        refreshGatewayErrorData,
        activateDeactivateGatewayErrorData,
        lastCommandStatusErrorData,
        deleteGatewayErrorData,
        installationReportErrorData,
        deleteAssetErrorData,
        moveToAnotherGatewayErrorData,
        downloadDiagnosticReportErrorData,
        validateSwitchGatewayAssetErrorData,
        connectionHistoryGateway
    ) => {
        return {
            gatewayInformation,
            gatewayConnectedAssets,
            generalFilterLoadingStatuses,
            selectedOrganization,
            isSwitchValid,
            validateSwitchLoadingStatus,
            gatewayAssetsList,
            gatewayAssetsListLoadingStatus,
            isSwitchEgwToAnotherGateway,
            isMoveValid,
            switchGatewayId,
            validationLoadingStatus,
            rebootGatewayErrorData,
            updateFirmwareErrorData,
            refreshGatewayErrorData,
            activateDeactivateGatewayErrorData,
            lastCommandStatusErrorData,
            deleteGatewayErrorData,
            installationReportErrorData,
            deleteAssetErrorData,
            moveToAnotherGatewayErrorData,
            downloadDiagnosticReportErrorData,
            validateSwitchGatewayAssetErrorData,
            connectionHistoryGateway
        };
    }
);
